<template>
	<main class="c-main">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between w-100">
							<div class="d-flex">
								<div class="form-group mr-4 w-50">
									<v-select label="name" :options="users" v-model="selected_users" :multiple="true"></v-select>
								</div>
                <div class="form-group mr-4">
                  <input type="text" class="form-control" placeholder="Код" v-model="filter.code">
                </div>
                <div class="form-group mr-4">
									<date-picker class="w-100" v-model="filter.beginDate" valueType="format" placeholder="Дата с"></date-picker>
								</div>
								<div class="form-group mr-4">
									<date-picker class="w-100" v-model="filter.endDate" valueType="format" placeholder="Дата до"></date-picker>
								</div>
								<div class="form-group mr-3">
									<button class="btn btn-success" @click="searchWithFilter()">Фильтр</button>
								</div>
								<div class="form-group mr-3">
									<button class="btn btn-success" @click="getExport()">Экспорт</button>
								</div>
								<div class="form-group">
									<button class="btn btn-success" style="text-wrap: nowrap"  @click="getExportData()">Экспорт 1</button>
								</div>

							</div>
						</div>

						<div class="table-responsive">
							<table class="table-striped table">
								<thead>
								<tr>
									<th>№</th>
									<th>Пользователь</th>
									<th>Действие</th>
									<th>Код</th>
									<th>Дата</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(item, index) in data" :key="index">
									<td>{{ index + 1}}</td>
									<td>{{ item.user.name }}</td>
									<td>{{ item.action }}</td>
									<td>{{ item.code }}</td>
									<td>{{ item.created_at }}</td>
								</tr>
								</tbody>
							</table>
						</div>

						<div class="row d-flex justify-content-end">
							<paginate
									:page-count="pagination.count"
									:page-range="3"
									:margin-pages="2"
									:click-handler="getCurrentPage"
									:prev-text="'<'"
									:next-text="'>'"
									:container-class="'pagination'"
									:page-class="'page-item'"
									:page-link-class="'page-link-item'"
									:prev-class="'prev-pagination'"
									:prev-link-class="'prev-link-pagination'"
									:next-class="'next-pagination'"
									:next-link-class="'next-link-pagination'"
							></paginate>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
	import { GET } from "@/shared/api";
import { RawGET } from '../../shared/api';
	export default {
		data() {
			return {
				data: [],
				users: [],
				selected_users: [],
				filter: {
					page: 1,
					perpage: 50
				},
				totalCount: 0,
				pagination: {
					count: 0,
					perpage: 50,
				}
			};
		},
		methods: {
			getData() {
				this.searchWithFilter();
			},
			searchWithFilter() {
				if(this.selected_users.length > 0){
					this.filter.users = [];
					this.selected_users.forEach(user=>{
						this.filter.users.push(user.id);
					});
				}
				GET(this.filter, "/user-actions", this, false).then(response => {
					this.data = response.data;
          this.data.forEach((act) => {
            if (act.user == null){
              act.user = {name:'Удаленный пользователь'};
            }
          });
					this.totalCount = response.total;
					this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
				});
			},
      getExport() {

				if(this.selected_users.length === 0 || typeof this.filter.beginDate !== 'string' || typeof this.filter.endDate !== 'string'){
          return;
				}

        let params = {
          user_id: this.selected_users[0].id,
          created_from: this.filter.beginDate,
          created_till: this.filter.endDate,
        };

        if (this.filter.code && this.filter.code.trim() !== '') {
          params.code = this.filter.code.trim();
        }

        let paramString = new URLSearchParams(params);

        window.open(`${process.env.VUE_APP_URL}/report/logs?${paramString.toString()}`).focus();

      },
      getExportData() {

				if(this.selected_users.length === 0 || typeof this.filter.beginDate !== 'string' || typeof this.filter.endDate !== 'string'){
          return;
				}

        let params = {
          user_id: this.selected_users[0].id,
          created_from: this.filter.beginDate,
          created_till: this.filter.endDate,
        };

        if (this.filter.code && this.filter.code.trim() !== '') {
          params.code = this.filter.code.trim();
        }

        let paramString = new URLSearchParams(params);

        window.open(`${process.env.VUE_APP_URL}/report/data-logs?${paramString.toString()}`).focus();

      },
			getCurrentPage(pageNumber) {
				this.filter.page = pageNumber;
				this.searchWithFilter();
			},
			getUsers() {
				GET([], "/user", this, false).then(response => {
					this.users = response;
				});
			},
		},
		mounted() {
      this.getUsers();
      this.getData();
		}
	};
</script>
